import {
  Snackbar,
  Alert,
  Button,
  Box,
  Typography,
} from "@mui/material";
import React from "react";
import { useSnackbar } from "../contexts/SnackbarContext";

const GlobalSnackbar: React.FC = () => {
  const { snackbarState, hideSnackbar } = useSnackbar();

  const handleAction = () => {
    if (snackbarState.onAction) {
      snackbarState.onAction();
    }
    hideSnackbar();
  };

  return (
    <Snackbar
      open={snackbarState.open}
      onClose={hideSnackbar}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        "& .MuiSnackbarContent-root": {
          minWidth: "auto",
        },
      }}
    >
      <Alert
        onClose={hideSnackbar}
        severity={snackbarState.severity}
        variant="filled"
        sx={{
          minWidth: "300px",
          maxWidth: "500px",
          py: 0.5,
          px: 2,
          "& .MuiAlert-message": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            py: 0.5,
          },
          "& .MuiAlert-action": {
            display: "none", // Hide default close button
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              flex: 1,
              fontWeight: 500,
              fontSize: "0.875rem",
              lineHeight: 1.4,
            }}
          >
            {snackbarState.message}
          </Typography>

          <Button
            size="small"
            onClick={snackbarState.actionLabel ? handleAction : hideSnackbar}
            sx={{
              color: "inherit",
              fontSize: "0.75rem",
              fontWeight: 600,
              textTransform: "uppercase",
              minWidth: "auto",
              px: 1.5,
              py: 0.5,
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            {snackbarState.actionLabel || "Close"}
          </Button>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
